/* eslint-disable import/no-cycle */
import {useState} from 'react';
import {Select, Table} from 'antd';
import {useTranslation} from 'react-i18next';
import {observer, Observer} from 'mobx-react-lite';
import {useStore} from '../../hooks/useStore';
import {useMount} from '../../hooks/useMount';
import {sortAlphabetically} from '../shared/tables/sorters';
import AlertWarning from '../shared/alert/AlertWarning';

const Reasons = ({onChange, value}) => {
  const store = useStore();
  const {t} = useTranslation();

  const availableReasonSourceIds = new Set(
    store.interruptionReasonStore.reasonsForSelectedWorkplace
      .filter((reason) => !reason.isQuickstop)
      .map((reason) => reason.reasonSourceId)
  );

  const availableSources = store.interruptionReasonSourceStore.sources
    .filter((source) => availableReasonSourceIds.has(source.id))
    .sort((a, b) => sortAlphabetically(a.name, b.name))
    .map(({id, name}) => ({label: name, value: id}));

  const [selectedSource, setSelectedSource] = useState(
    !value && availableSources.length > 0 ? availableSources[0].value : value
  );

  useMount(() => {
    store.interruptionReasonSourceStore.loadAll();
    store.interruptionReasonStore.loadAll()
      .then(() => {
        if (value) {
          const reasonSource = store.interruptionReasonStore.getById(value);
          setSelectedSource(reasonSource.reasonSourceId);
        }
      });
  });

  const dataSource = store.interruptionReasonStore.reasonsForSelectedWorkplace
    .filter((reason) => !reason.isQuickstop && (!selectedSource || (reason.reasonSourceId === selectedSource)))
    .map(({id, name, description}) => ({
      key: id,
      name,
      description,
    }));

  const columns = [
    {
      title: t('interruption.modal.form.reason.name'),
      dataIndex: 'name',
      key: 'name',
    },
  ];

  const getDefaultSelectValue = () => {
    const ids = availableSources.map((source) => Number(source.value));
    return ids[0];
  };

  const showNoReasonAlert = !dataSource.length && !store.interruptionReasonStore.isLoadingCollection;

  return (
    <>
      {showNoReasonAlert ? (
        <AlertWarning
          message={t('interruption.modal.form.reason.noReasonsConfigured')}
          closable
        />
      ) : null}
      <Observer>
        {
          () => (
            <Select
              placeholder={t('interruption.modal.form.reason.placeholder')}
              options={availableSources}
              value={selectedSource || getDefaultSelectValue()}
              onChange={(selected) => setSelectedSource(selected)}
              disabled={!availableSources.length}
            />
          )
        }
      </Observer>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        onRow={(record) => ({
          onClick: () => onChange(record.key),
        })}
        rowSelection={{
          type: 'radio',
          onChange: (values) => onChange(values[0]),
          selectedRowKeys: [value],
        }}
      />
    </>
  );
};

export default observer(Reasons);
